import { styled } from '@mui/material/styles';
import { Stack } from 'core/common/ui/ui-kit';

export const ContainerStyled = styled(Stack)`
  a {
    text-decoration: underline;
  }
`;
